import { Pipe, PipeTransform } from '@angular/core';
import { CommonUtils } from '../common.utils';

@Pipe({
    name: 'getvalue'
})

export class GetValuePipe implements PipeTransform {

    constructor(private utils: CommonUtils) {}

    transform(field: any, ...args: any[]): any {
        return this.utils.getValue(field, args[0], args[1]);
    }
}